const $ = jQuery.noConflict();
import Global from '../shared/global';

'use strict';
const accordian = {

	$accordianItem: $('.js-acc-item'),
	$accordianContent: $('.js-acc-item-content'),

	$faqCol: $('.js-faq-col'),
	$faqTitle: $('.js-faq-title'),
	$faqContent: $('.js-faq-content'),

	init: function() {
		this.bindEvents();
		Global.escKey(this.closeAccordian);
		this.appendTitle();
	},

	bindEvents: function() {
		this.$accordianItem.on('click', this.openAccordian);
		$(window).resize(function() {
			accordian.appendTitle();
		});
	},

	openAccordian: function(e) {
		if (e.target.tagName.toLowerCase() !== 'a') {
			if ($(this).hasClass('js-acc-btn')) {
				$(this).toggleClass('active').siblings('.js-acc-item-content').slideToggle('medium');
				accordian.$accordianItem.not(this).removeClass('active').siblings('.js-acc-item-content').slideUp('medium');
			} else {
				$(this).toggleClass('active').find('.js-acc-item-content').slideToggle('fast');
				accordian.$accordianItem.not(this).removeClass('active').find('.js-acc-item-content').slideUp('fast');
			}
		}
	},

	closeAccordian: function() {
		accordian.$accordianItem.removeClass('active');
		accordian.$accordianContent.slideUp('fast');
	},


	appendTitle: function() {
		if ($(window).width() < 992) {
			accordian.$faqTitle.appendTo(accordian.$faqCol);
		} else {
			accordian.$faqTitle.appendTo(accordian.$faqContent);
		}
	},

};

export default accordian;
